/**
 * External Dependencies
 */
import 'jquery'; // jQuery

import AOS from 'aos'; // Animate On Scroll
import SmoothScrollTop from 'smooth-scroll-top'; // Smooth Scroll Top

import './components/responsive';

//import MmenuLight from 'mmenu-light'; // Mobile Menu Light
// import Mhead from 'mhead-js'; // Sticky header
import '@fortawesome/fontawesome-free/js/all';

/* import mmenu + menu */
import 'mmenu-js';
import './components/menu';

import Swiper from 'swiper/bundle'; // Swiper JS
import 'swiper/css/bundle'; // import Swiper styles

$(() => {

  /**
   * WP Evo Theme version
   */
  console.log('- 💎 WP Evo Theme v0.0.1 - Made with 💗 - ©️ S2i Evolution');

  ///////// Init AOS  /////////
  AOS.init({
    //disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    disable: 'mobile',
    once: true,
    animatedClassName: 'aos-animate', // class applied on animation
  });
  console.log('[lib] > Animate On Scroll loaded');


  ///////// Init Smooth Scroll Top  /////////
  const scrollTop = new SmoothScrollTop({
    position: 'right',
    bgColor: '#23748c',
  });
  scrollTop.init();
  console.log('[lib] > Smooth Scroll Top loaded');


  //////// Init Swiper /////////
  // eslint-disable-next-line
  const slider = new Swiper('.mySwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 10000000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Responsive
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
    mousewheel: false,
    keyboard: true,
  });
  console.log('[lib] > Swiper loaded');

  ///// CLIC SUR LES CARDS /////
  // $('.card-click').on('click', function () {
  //   document.location.href = $(this).find('a').attr('href');
  // });

  check_header();
  $(window).on("scroll", check_header);
  $(window).on("resize", check_header);


  ///// SCROLL /////
  $(".btn").addClass("scroll");
  $(".menu-item a").addClass("scroll");

  $('.scroll').on('click', function () { // Au clic sur un élément
    scrollTo(this.hash, 750);
  });

  $(document).on("scroll", onScroll);

});

function scrollTo(page, speed) {
  $('html, body').animate({ scrollTop: $(page).offset().top - $('header').height() }, speed); // Go
  return false;
}

///// MENU ACTIVE AU SCROLL /////
function onScroll(event) {
  var scrollPos = $(document).scrollTop();
  $('#menu-menu .menu-item').each(function () {
    var currLink = $(this).find('a');
    var refId = currLink.prop("hash");
    var refElement = $(refId);
    var elementTop = (refElement.offset().top - $('header').height());
    if (elementTop - 1 <= scrollPos && elementTop + refElement.height() > scrollPos) {
      $('#menu-menu .menu-item').removeClass("current");
      currLink.parent().addClass("current");
    }
    else {
      currLink.removeClass("current");
    }
  });
}

///// FIXED HEADER /////
function check_header() {
  if ($(window).scrollTop() < 1 && $(window).width() > 992) {
    $("header").removeClass("second_style");
  }
  if ($(window).scrollTop() >= 1 || $(window).width() < 992) {
    $("header").addClass("second_style");
  }
}


